// Tracks status_calling values changed via the in-row dropdown after the grid
// data was fetched. GridJS sorts the Status Calling column client-side using
// the cached cell HTML, which becomes stale after a dropdown change — these
// overrides give the sort a way to read the current value.

const statusCallingOverrides: Record<string, string> = {}

export function setStatusCallingOverride(prospectId: string, status: string): void {
  if (!prospectId) return
  statusCallingOverrides[prospectId] = status
}

export function clearStatusCallingOverrides(): void {
  for (const key of Object.keys(statusCallingOverrides)) {
    delete statusCallingOverrides[key]
  }
}

export function getStatusFromStatusCallingCell(cell: unknown): string {
  if (typeof cell !== 'string') return ''

  const idMatch = cell.match(/data-bots-prospect-id="([^"]+)"/)
  if (idMatch) {
    const override = statusCallingOverrides[idMatch[1]]
    if (override != null) return override
  }

  const classMatch = cell.match(/class="form-control status_calling ([^"]*)"/)
  return classMatch ? classMatch[1].trim() : ''
}
